export interface IDescriptor {
  id: string
  description: string
}
